import { ReactElement, useEffect, useState } from "react";
import { Link, useLoaderData } from "react-router-dom";
import { useUser } from "../../Providers/UserProvider";
import { useApi } from "../../Providers/ApiProvider";
import { IItem } from "../../models/IItem";
import { Mondrian, MondrianColumn, MondrianInputObject } from "@spt/mondrian";
import dayjs from "dayjs";

export function UGEAFHistoricalApps(): ReactElement {
  var load: { UCASNo: string } = useLoaderData() as { UCASNo: string };
  var data = useApi();
  var user = useUser();
  var [error, setError] = useState("");
  var [rData, setRData] = useState(undefined);
  var [items, setItems] = useState(Array<MondrianInputObject>);
  var [loading, setLoading] = useState(true);

  useEffect(() => {
    data.General.getEdocs(load.UCASNo, user.Alias, ["uaducasform"]).then(
      (data) => {
        setRData(data);
      },
      (reason) => {
        setError(reason);
      },
    );
  }, []);

  useEffect(() => {
    if (rData !== undefined) {
      var MIOs: MondrianInputObject[] = [];

      console.log(rData);

      var _rData = rData as IItem[][];

      if (_rData.length > 0) {
        _rData.forEach((grid) => {
          //  console.log(grid);

          grid.forEach((item) => {
            //  console.log(item);

            let _sh = item["SUBHEADER"];
            //  console.log("SUBHEADER?");
            //  console.log(_sh);

            let thisItem: MondrianInputObject = {};

            if (_sh !== undefined && _sh !== "") {
              thisItem = { SUBHEADER: _sh };
            } else {
              let crdat = dayjs(item["Created Date"]);

              thisItem = {
                CreatedDate: {
                  _TYPE: "String",
                  StringValue:
                    crdat === null || crdat === undefined
                      ? ""
                      : crdat.format("DD/MM/YYYY HH:mm:ss"),
                  SortingValue:
                    crdat === null || crdat === undefined ? "" : crdat,
                },
                UploadedBy: item["Uploaded By"],
                ViewFile: {
                  _TYPE: "Element",
                  ElementValue: (
                    <Link to={item.Filename_URL} target="_blank">
                      {item.Filename !== undefined
                        ? item.Filename
                        : item._LibraryURL !== undefined
                          ? item._LibraryURL.split("/").lastItem.split(".")[0] +
                            "." +
                            item._previewType
                          : item.Filename_URL !== undefined
                            ? item.Filename_URL.split("/").lastItem
                            : "File"}
                    </Link>
                  ),
                  SortingValue: undefined,
                  GroupingValue: undefined,
                },
                Size: item.Size,
              };
            }

            /*
                            Created Date : "2024-11-25T16:41:40.0000000Z"
                            Document Type : "Application Form"
                            Filename : "uaducasform_1867066404_1732552804"
                            Filename_FLAG : ""
                            Filename_ICON : "https://localhost:7250/icon/icpdf.png"
                            Filename_ICONFLAG : ""
                            Filename_URL : "/UGEAF/1867066404/Document/e9de6f5e-f476-4634-a41c-eaba8e5756d3::216aec41-bf73-4000-a5a4-1d580ec8fefd::d07e8406-d4e3-4435-b465-a308a32feda4/pdf"
                            Size : "10.5KB"
                            Uploaded By : "SharePoint App"
                            Visa Doc : ""
                            Visa Doc_CSS : ""
                            _EditURL : "Metadata/e9de6f5e-f476-4634-a41c-eaba8e5756d3::216aec41-bf73-4000-a5a4-1d580ec8fefd::d07e8406-d4e3-4435-b465-a308a32feda4"
                            _LibraryURL : "https://localhost:7250/raw/1867066404/e9de6f5e-f476-4634-a41c-eaba8e5756d3::216aec41-bf73-4000-a5a4-1d580ec8fefd::d07e8406-d4e3-4435-b465-a308a32feda4/uaducasform_1867066404_1732552804.pdf"
                            _PreviewURL : "/UGEAF/1867066404/Document/e9de6f5e-f476-4634-a41c-eaba8e5756d3::216aec41-bf73-4000-a5a4-1d580ec8fefd::d07e8406-d4e3-4435-b465-a308a32feda4/pdf"
                            _ViewURL : "/UGEAF/1867066404/Document/e9de6f5e-f476-4634-a41c-eaba8e5756d3::216aec41-bf73-4000-a5a4-1d580ec8fefd::d07e8406-d4e3-4435-b465-a308a32feda4/pdf"
                            _cacheId : "e9de6f5e-f476-4634-a41c-eaba8e5756d3::216aec41-bf73-4000-a5a4-1d580ec8fefd::d07e8406-d4e3-4435-b465-a308a32feda4"
                            _ident : "1867066404"
                            _previewType : "pdf"
                        */

            MIOs.push(thisItem);
          });
        });
      }

      //  d["SUBHEADER"] = `<a href='${data[0][0]["Filename_URL"]
      //      }' target='_blank'><img src='${data[0][0]["Filename_ICON"]
      //      }'/>Application Form <small>(${new Date(
      //          data[0][0]["Created Date"],
      //      ).toLocaleDateString("en-GB")}, ${new Date(
      //          data[0][0]["Created Date"],
      //      ).toLocaleTimeString("en-GB")})</small></a>`;

      setItems(MIOs);
      setLoading(false);
    }
  }, [rData]);

  const columns: MondrianColumn[] = [
    {
      HumanName: "View File",
      MachineName: "ViewFile",
      Sortable: false,
      Groupable: false,
      Filterable: false,
      Hideable: false,
    },
    {
      HumanName: "Uploaded By",
      MachineName: "UploadedBy",
      Sortable: true,
      Groupable: true,
      Filterable: false,
      Hideable: false,
    },
    {
      HumanName: "Created Date",
      MachineName: "CreatedDate",
      Sortable: true,
      Groupable: false,
      Filterable: false,
      Hideable: false,
    },
    {
      HumanName: "Size",
      MachineName: "Size",
      Sortable: false,
      Groupable: false,
      Filterable: false,
      Hideable: false,
    },
  ];

  return (
    <div className="UGEAF">
      <h2>Historical Application Forms for {load.UCASNo}</h2>
      <Mondrian
        Name="HistApps"
        InputObjects={items}
        LoadingFlag={loading}
        Columns={columns}
        Settings={{
          GroupAndSortSettings: {
            ShowSubcount: true,
            Defaults: [],
          },
          PagerSettings: {
            ResultsPerPage: 10,
          },
        }}
        Caption={
          "All UCASDA print views generated over time for this applicant."
        }
        Debug={false}
      ></Mondrian>
    </div>
  );
}
